import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectFilter = ({ categories, technologies, selectedCategory, selectedTech, onCategoryChange, onTechChange, onClearFilters, projectCount }) => {
  return (
    <div className="bg-card border border-border rounded-xl p-6 mb-8">
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
        {/* Filter Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Icon name="Filter" size={20} className="text-primary" />
            <h3 className="text-lg font-semibold text-foreground">Filter Projects</h3>
            <span className="px-2 py-1 text-xs font-medium bg-primary/10 text-primary rounded-full">{projectCount} projects</span>
          </div>
          {(selectedCategory !== 'All' || selectedTech !== 'All') && (
            <Button variant="ghost" size="sm" iconName="X" iconPosition="left" onClick={onClearFilters} className="text-muted-foreground hover:text-foreground">Clear</Button>
          )}
        </div>

        {/* Filters */}
        <div className="flex flex-col sm:flex-row gap-4">
          {/* Category Filter */}
          <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-foreground">Category</label>
            <div className="flex flex-wrap gap-2">
              {categories?.map((category) => (
                <button key={category} onClick={() => onCategoryChange(category)} className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${selectedCategory === category ? 'bg-primary text-primary-foreground shadow-sm' : 'bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground'}`}>{category}</button>
              ))}
            </div>
          </div>

          {/* Technology Filter */}
          <div className="flex flex-col gap-2">
            <label className="text-sm font-medium text-foreground">Technology</label>
            <div className="flex flex-wrap gap-2">
              {technologies?.map((tech) => (
                <button key={tech} onClick={() => onTechChange(tech)} className={`px-3 py-1.5 text-sm font-medium rounded-lg transition-colors ${selectedTech === tech ? 'bg-accent text-accent-foreground shadow-sm' : 'bg-muted text-muted-foreground hover:bg-muted/80 hover:text-foreground'}`}>{tech}</button>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectFilter;
